import React from 'react';
import cn from 'classnames';
import { useSelector } from 'react-redux';

import { Form } from 'ui/components';

const initialState = {
  items: [
    {
      id: null,
      plan_item: null,
      item_id: null,
      quantity_planned: null,
      quantity_received: null,
      quantity_defect: null
    },
  ],
};

export const FormItems = ({ data, plan, onItemChange }) => {
  const StateForm = useSelector((state) => state?.Form);
  const [{ items }, setState] = React.useState(initialState);

  const $handleOnCheck = async(i) => {
    let newItems = [...items];

    newItems[i]['quantity_received'] = newItems[i].quantity_planned;

    setState((prevState) => ({
      ...prevState,
      items: newItems,
    }));
  }

  const $handleItemsChange = async (i, e, name) => {
    let newItems = [...items];

    newItems[i][name] = e.target.valueNumber;

    setState((prevState) => ({
      ...prevState,
      items: newItems,
    }));
  };

  React.useEffect(() => {
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }, 2000);
  }, []);

  React.useEffect(() => {
    const state = {
      items,
    };

    onItemChange(state);
  }, [items]);

  React.useEffect(() => {
    if (!plan) return;

    if (data) return;

    let b = [];
    if (plan) {
      plan?.items?.forEach((i) => {
        b.push({
          plan_item: i,
          item_id: i?.id,
          quantity_planned: i?.quantity_planned,
          quantity_received: null,
          quantity_defect: null,
        });
      });
    }
    setState((prevState) => ({ ...prevState, items: b }));
  }, [plan]);

  React.useEffect(() => {
    if (!plan && !data) return;

    let b = [];
    if (plan) {
      plan?.items?.forEach((i) => {
        let pi = {
          plan_item: i,
          item_id: i?.id,
          quantity_planned: i?.quantity_planned,
          quantity_received: null,
          quantity_defect: null,
        }

        data?.items?.forEach((di) => {
          if (di.plan_item_id === i.id) {
            pi.id = di?.id
            pi.quantity_received = di.quantity_received
            pi.quantity_defect = di.quantity_defect
          }
        })

        b.push(pi);
      });
    }
    setState((prevState) => ({ ...prevState, items: b }));
  }, [plan, data]);

  return (
    <div className='bg-white py-md-3 px-3 border-top border-bottom'>
      <div className="row">
        <div className="col-12">
          <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
            Receiving Plan Item
          </div>
          <div className="table-responsive bg-white">
            <table
              width="100%"
              className="table table-hover table-vcenter card-table datatable border"
            >
              <thead className="bg-light">
                <tr className="th">
                  <td style={{width: '5%'}}>No</td>
                  <td
                    style={{
                      whiteSpace: 'nowrap',
                      width: '40%',
                    }}
                  >
                    Item
                  </td>
                  <td
                    style={{
                      whiteSpace: 'nowrap',
                      width: '10%',
                      textAlign: 'center',
                    }}
                  >
                    Quantity Planned
                  </td>
                  <td
                    style={{
                      whiteSpace: 'nowrap',
                      width: '15%',
                      textAlign: 'center',
                    }}
                  >
                    Quantity Diterima
                  </td>
                  <td></td>
                  <td
                    style={{
                      whiteSpace: 'nowrap',
                      width: '15%',
                      textAlign: 'center',
                    }}
                  >
                    Quantity Rusak
                  </td>
                  <td></td>
                  <td style={{width: '8%'}}></td>
                </tr>
              </thead>
              <tbody>
                {items?.map((d, i) => (
                  <tr
                    key={i}
                    className={cn(
                      StateForm?.errors[`items.${i}.item_id`] || StateForm?.errors?.items
                        ? 'text-dangers border-danger'
                        : null
                    )}
                  >
                    <td>{i + 1}</td>
                    <td style={{ whiteSpace: 'nowrap', width: '40%' }}>
                      <div className="table-col text-uppercase">
                        <div className="fs-8 fw-semibold">
                          {d?.plan_item?.item?.alias_name}
                        </div>
                        <small className="info text-ellipsis">{d?.plan_item?.item?.code}</small>
                      </div>
                      {StateForm?.errors[`items.${i}.item_id`] || StateForm?.errors?.items ? (
                        <div className="invalid-feedback d-block ">
                          {StateForm?.errors[`items.${i}.item_id`] || StateForm?.errors?.items}
                        </div>
                      ) : null}
                    </td>
                    <td style={{ whiteSpace: 'nowrap', width: '40%' }}>
                      <div className="table-col text-center text-uppercase">
                        <div className="fs-8 fw-semibold">
                          {d?.quantity_planned} {d?.plan_item?.item?.default_fraction}
                        </div>
                        <small className="info text-ellipsis">{d?.plan_item?.quantity_planned_fracted}</small>
                      </div>
                    </td>
                    <td style={{ whiteSpace: 'nowrap', width: '40%' }}>
                      <Form.Input
                        autoComplete="off"
                        name="quantity_received"
                        type="number"
                        value={d?.quantity_received}
                        onChange={(e) => $handleItemsChange(i, e, 'quantity_received')}
                        error={
                          StateForm?.errors[`items.${i}.quantity_received`]
                        }
                        mb0
                        withFraction={d?.plan_item?.item?.default_fraction}
                      />
                    </td>
                    <td style={{ whiteSpace: 'nowrap'}}>
                      {d?.plan_item?.item?.default_fraction}
                    </td>
                    <td style={{ whiteSpace: 'nowrap', width: '40%' }}>
                      <Form.Input
                        autoComplete="off"
                        name="quantity_defect"
                        type="number"
                        value={d?.quantity_defect}
                        onChange={(e) => $handleItemsChange(i, e, 'quantity_defect')}
                        error={
                          StateForm?.errors[`items.${i}.quantity_defect`]
                        }
                        mb0
                        withFraction={d?.plan_item?.item?.default_fraction}
                      />
                    </td>
                    <td style={{ whiteSpace: 'nowrap'}}>
                      {d?.plan_item?.item?.default_fraction}
                    </td>
                    <td className="text-end">
                      <div
                        className="btn-toolbar justify-content-end"
                        role="toolbar"
                      >
                        <div className="input-group" role="group">
                          <input className="form-check-input mt-0" type="checkbox" onClick={() => $handleOnCheck(i)}/>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
